import { render } from "./Edit.vue?vue&type=template&id=1ad96a42&scoped=true"
import script from "./Edit.vue?vue&type=script&lang=js"
export * from "./Edit.vue?vue&type=script&lang=js"

import "./Edit.vue?vue&type=style&index=0&id=1ad96a42&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ad96a42"],['__file',"src/views/DataExchange/Edit.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1ad96a42"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1ad96a42', __exports__)) {
    api.reload('1ad96a42', __exports__)
  }
  
  module.hot.accept("./Edit.vue?vue&type=template&id=1ad96a42&scoped=true", () => {
    api.rerender('1ad96a42', render)
  })

}


export default __exports__